import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  FoodCardPassReasonRecord,
  FoodCardPassReasonService,
  PassFoodCardRequest,
} from '@libs/shared/api';
import { Observable } from 'rxjs';
import { allAllowInElements } from '@libs/shared/utils/const/shortcut';
import { injectHotkeyManagerService } from '@libs/shared/hotkey/hotkey-manager.service';

@Component({
  selector: 'app-pass-food-card-dialog',
  template: `
    <h1 mat-dialog-title class="text-xl font-bold">
      패스하는 이유는 무엇인가요?
    </h1>
    <div mat-dialog-content>
      <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
        <div class="w-100 flex flex-col gap-2">
          <mat-radio-group formControlName="reasonId">
            <div class="flex flex-col gap-2 p-2">
              @for (passReason of foodCardPassReasons$ | async; track passReason) {
                <mat-radio-button
                  [value]="passReason.id">
                  {{ passReason.description }}
                </mat-radio-button>
              }
            </div>
          </mat-radio-group>
          <mat-form-field
            [floatLabel]="'always'"
            class="fuse-mat-no-header w-full"
            appearance="fill">
            <textarea
              matInput
              formControlName="remark"
            placeholder="추가 메시지 (Shift+Enter: 줄바꿈)"></textarea>
          </mat-form-field>
        </div>
      </form>
    </div>
    <div mat-dialog-actions class="flex flex-row justify-end">
      <button mat-stroked-button (click)="onClose()">취소</button>
      <button
        mat-flat-button
        color="warn"
        [disabled]="form.invalid"
        (click)="onSubmit()">
        패스
      </button>
    </div>
    `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassFoodCardDialogComponent implements AfterViewInit, OnDestroy {
  form: FormGroup;
  readonly foodCardPassReasonService = inject(FoodCardPassReasonService);
  readonly hotkeyManager = injectHotkeyManagerService();

  foodCardPassReasons$: Observable<FoodCardPassReasonRecord[]>;

  constructor(
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<
      PassFoodCardDialogComponent,
      PassFoodCardRequest
    >
  ) {
    this.initForm();
    this.foodCardPassReasons$ =
      this.foodCardPassReasonService.fetchFoodCardPassReasons(true);
  }

  ngAfterViewInit(): void {
    this.hotkeyManager.activateHotkeysForComponent(this.constructor.name, [
      {
        keys: 'meta.enter',
        description: '저장하기',
        allowIn: allAllowInElements,
        action: () => {
          this.onSubmit();
        },
      },
      {
        keys: 'escape',
        description: '닫기',
        allowIn: allAllowInElements,
        action: () => {
          this.onClose();
        },
      },
    ]);
  }

  ngOnDestroy(): void {
    this.hotkeyManager.deactivateHotkeys(this.constructor.name);
  }

  onSubmit() {
    if (this.form.valid) {
      this.matDialogRef.close(this.form.value);
    }
  }

  onClose() {
    this.matDialogRef.close();
  }

  initForm() {
    this.form = this.fb.group({
      reasonId: [null, Validators.required],
      remark: [null],
    });
  }
}
